module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Projetos'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Projetos")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Projeto',
        href: '#'
      }, {
        text: 'Lista',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-rocket",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Projetos "), (!_vm.loading.show) ? _c('span', {
    staticStyle: {
      "font-size": "small",
      "color": "var(--cor-fraca)"
    }
  }, [_vm._v(_vm._s(_vm.tableProjetos.totalRows) + " localizado(s)")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    class: (_vm.usuarioLogado.userType === 'FUNDACAO' ? 'col-md-offset-3 col-md-5' : 'col-md-offset-4 col-md-5')
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa),
      expression: "pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa..."
    },
    domProps: {
      "value": (_vm.pesquisa)
    },
    on: {
      "keyup": _vm.ajustaPesquisa,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pesquisa = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "disabled": !_vm.tableProjetos.filter,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.tableProjetos.filter = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Carteira:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carteiraSelecionada),
      expression: "carteiraSelecionada"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm.configuracoes.tela_projetos.codigoCarteira
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.carteiraSelecionada = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.selecionaCarteira]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todos os projetos")]), _vm._v(" "), _vm._l((_vm.listaCarteiras), function(carteira) {
    return _c('option', {
      domProps: {
        "value": carteira.usu_codcart
      }
    }, [_vm._v(_vm._s(carteira.usu_nomcart))])
  })], 2)])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": _vm.tableProjetos.bordered,
      "items": _vm.itemsProjetos,
      "fields": _vm.fieldsProjetos,
      "current-page": _vm.tableProjetos.currentPage,
      "per-page": _vm.tableProjetos.perPage,
      "filter": _vm.tableProjetos.filter,
      "filter-function": _vm.filtroPorItem,
      "empty-filtered-text": "Nada foi encontrado. Refaça sua pesquisa!",
      "empty-text": "Nenhum registro encontrado",
      "sort-by": _vm.tableProjetos.sortBy,
      "sort-desc": _vm.tableProjetos.sortDesc
    },
    on: {
      "filtered": _vm.onFiltered,
      "update:sortBy": function($event) {
        return _vm.$set(_vm.tableProjetos, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.tableProjetos, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.tableProjetos, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.tableProjetos, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(row) {
        return [_c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'projeto',
                params: {
                  numero: row.item.ds_codigo_projeto_erp
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-rocket",
          attrs: {
            "aria-label": "false"
          }
        }), _vm._v(" Projeto")]), _vm._v(" "), (_vm.usuarioLogado.userType !== 'PARCEIRO_ESTRATEGICO') ? _c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'visualiza-relatorio-execucao',
                params: {
                  id: row.item.id
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-calendar-check-o",
          attrs: {
            "aria-label": "false"
          }
        }), _vm._v(" Relatório")]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType !== 'PARCEIRO_ESTRATEGICO' && row.item.ds_codigo_projeto_erp) ? _c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'emissao-documentos',
                params: {
                  numero: row.item.ds_codigo_projeto_erp
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file",
          attrs: {
            "aria-label": "false"
          }
        })]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType !== 'PARCEIRO_ESTRATEGICO' && row.item.qtdeAvaliacoesProjeto > 0) ? _c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return row.toggleDetails()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil",
          attrs: {
            "aria-label": "false"
          }
        }), _vm._v("\n                        " + _vm._s(row.item.qtdeAvaliacoesProjeto) + " " + _vm._s(row.item.qtdeAvaliacoesProjeto > 1 ? 'Avaliações' : 'Avaliação') + "\n                      ")]) : _vm._e()]
      }
    }, {
      key: "row-details",
      fn: function(row) {
        return [_c('avaliacoes-projeto', {
          attrs: {
            "numeroProjeto": row.item.ds_codigo_projeto_erp,
            "editavel": true
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.tableProjetos.totalRows,
      "per-page": _vm.tableProjetos.perPage
    },
    model: {
      value: (_vm.tableProjetos.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.tableProjetos, "currentPage", $$v)
      },
      expression: "tableProjetos.currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingShow),
      expression: "loadingShow"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])], 1)])])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-579b1c03!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projetos/ListaProjetos.vue
// module id = 1909
// module chunks = 2